import { Component, createElement, createRef, h } from 'preact';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class AccountIcon extends Component {

	state = {
		user: null
	};

	constructor(props) {
		super();
		this.state = {
			user: window.tccdata.name
		}
	}

	render(props, state) {
		return (
			<a href={this.props.href} class={'gumnut-store-selector header-item'}>
				<span class={'gumnut-store-selector-icon header-item__icon-wrapper'}>
					<FontAwesomeIcon icon={faUser}/>
				</span>
				{ !state.user && this.renderGuest(state) }
				{ state.user && this.renderUser(state) }
			</a>
		)
	}

	renderUser(state) {
		return (
			<div class={'header-item__content-wrapper'}>
				<span>Your account</span>
				<span dangerouslySetInnerHTML={{__html: state.user}}/>
			</div>
		)
	}

	renderGuest(state) {
		return (
			<div class={'header-item__content-wrapper'}>
				<span>Your Account</span>
				<span>Sign In or Sign Up</span>
			</div>
		)
	}
}
